import { AxiosPromise } from "axios";
import configs from "../configs";
import { DashboardLiveApi } from "./live/DashboardLiveApis";



export class DashboardApi {
    private static dashboardApi: DashboardLiveApi = new DashboardLiveApi();
    
    static uploadBankDoc(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.uploadBankDoc(data);
        }
    }


    static uploadKyc(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.uploadKyc(data);
        }
    }

    static applyStudentLoan(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.applyStudentLoan(data);
        }
    }

    static makeSchoolPayment(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makeSchoolPayment(data);
        }
    }   

    static makePayment(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makePayment(data);
        }
    } 


    static makePaymentFromWallet(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makePaymentFromWallet(data);
        }
    } 


    

    static makePaymentWithInterswitch(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makePaymentWithInterswitch(data);
        }
    } 

    static addSchool(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.addSchool(data);
        }
    }  

    static getAllSchool(pageNo:any,query:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getAllSchool(pageNo,query);
        }
    } 

    static getSchoolList(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSchoolList();
        }
    } 
 

    static getPaymentHistory(pageNo:any,query:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getPaymentHistory(pageNo,query);
        }
    }

    static getPendingPaymentHistory(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getPendingPaymentHistory();
        }
    }


    

    static getPaymentDetail(id:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getPaymentDetail(id);
        }
    }
    
    

    static getCallback(reference:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getCallback(reference);
        }
    }

    static verifyLoan(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyLoan();
        }
    }

    static verifyKyc(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyKyc();
        }
    }

    
    static getKycStatus(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getKycStatus();
        }
    }
    
    static getVirtualAccount(currency: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getVirtualAccount(currency);
        }
    }
    static getWallets(currency: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getWallets(currency);
        }
    }
    
    static createWallet(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createWallet(data);
        }
    } 

    // NEW MAPLERAD METHODS
    static getMapleradEnrollmentEligibility(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getMapleradEnrollmentEligibility();
        }
    } 

    static createMapleradVirtualAccount(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createMapleradVirtualAccount();
        }
    } 
    
    static enrollCustomer(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.enrollCustomer();
        }
    } 
    
    static updatePassword(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.updatePassword(data);
        }
    } 
    
    static updateProfilePicture(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.updateProfilePicture(data);
        }
    } 

    static initiateUpdateTransactionPin(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.initiateUpdateTransactionPin();
        }
    }
    
    static verifyTransactionPinOtp(data: { otp: string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyTransactionPinOtp(data);
        }
    }
    
    static setNewTransactionPin(data: { pin: string, confirm_pin: string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.setNewTransactionPin(data);
        }
    }
    
    static verifyTransactionPin(data: { pin: string}): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyTransactionPin(data);
        }
    }
    
    static createCard(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createCard(data);
        }
    }
 
    static getCardDetails(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getCardDetails();
        }
    }
    
    static freezeCard(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.freezeCard();
        }
    }

    static unfreezeCard(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.unfreezeCard();
        }
    }
    static fundCard(data:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.fundCard(data);
        }
    }
    static withdrawFromCard(data:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.withdrawFromCard(data);
        }
    }
    
    static deleteCard(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.deleteCard();
        }
    }
    
    static getCardSpendingUsage(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getCardSpendingUsage();
        }
    }

    
    static getCardTransactions(page: any, limit: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getCardTransactions(page,limit);
        }
    }
   
    
    static getFxQuote(data: { source_amount: number, source_currency: string, target_currency:string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getFxQuote(data);
        }
    }
    
    static performFxSwap(data: { internal_reference: string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.performFxSwap(data);
        }
    }
    
    static getLatestRates(data: { source_amount: number; source_currency: string; target_currency: string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getLatestRates(data);
        }
    }

    
    static getLatestRatesOnWebsite(data: { source_amount: number, source_currency:string, target_currency:string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getLatestRatesOnWebsite(data);
        }
    }

    
    static getAllRatesOnWebsite(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getAllRatesOnWebsite();
        }
    }
    
    static setDeleteAccount(data: { password: string, reason: string }): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.setDeleteAccount(data);
        }
    }
    
    static resendTransactionPinOtp(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.resendTransactionPinOtp();
        }
    }

    static addressVerification(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.addressVerification(data);
        }
    } 
    
    static getVerificationDetails(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getVerificationDetails();
        }
    }
    

    static generalVerification(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.generalVerification(data);
        }
    } 
   
    static identityVerification(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.identityVerification(data);
        }
    } 
    
    static uploadProfilePicture(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.uploadProfilePicture(data);
        }
    }
    
    static getUserProfile(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getUserProfile();
        }
    }

    static swap(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.swap();
        }
    }

    
    static getAllRates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getAllRates();
        }
    }


    static generateQuote(data:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.generateQuote(data);
        }
    }

    

    static createDynamicAccount(data:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createDynamicAccount(data);
        }
    }


    static getDashboardData(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getDashboardData();
        }
    }

    static verifyInterswitchPayment(reference:any,amount:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyInterswitchPayment(reference,amount);
        }
    }


    static createCreditEligibility(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createCreditEligibility(data);
        }
    }

    static getSingleCreditEligibity(id:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSingleCreditEligibity(id);
        }
    } 

    static createSchoolForm(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createSchoolForm(data);
        }
    }

    static applyStudyLoan(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.applyStudyLoan(data);
        }
    }

    static admissionProcess(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.admissionProcess(data);
        }
    }


    static getSingleSchoolForm(id:any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSingleSchoolForm(id);
        }
    }

}